import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { put, select } from 'redux-saga/effects';
import { getGallectionById } from '../selectors';
import { putEntities } from '../../redux/entities/actions';
import { normalizeGallection } from '../../redux/normalizr/helpers';
function* updateGallectionSize(folderId, delta) {
    const gallection = yield select(getGallectionById, folderId);
    if (!gallection) {
        return;
    }
    const updatedGallection = _object_spread_props(_object_spread({}, gallection), {
        size: gallection.size + delta
    });
    const entities = normalizeGallection(updatedGallection);
    yield put(putEntities({
        entities
    }));
}
export default updateGallectionSize;
